import React, { useState, useEffect, useCallback } from 'react';
import OrgWidePermissionsTable from './OrgWidePermissionsTable';
import './App.css';

function App({ keycloak, isAuthenticated }) {

  // Solo cargar los videos si el usuario está autenticado
  useEffect(() => {
    if (isAuthenticated) {
      //fetchVideos(); // Cargar los videos cuando esté autenticado
    }
  }, [isAuthenticated]);

  return <OrgWidePermissionsTable/>;
}

export default App;
